__webpack_require__.p = "https://cdn.sheetgo.com/webapp/prod/prod.candidate.2.6.45a-gummy-bear-launchpad-III-c-II/";